// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__DKTJ2","col":"styles_col__A5Gx-"};